import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useModelPopup } from "../../../../../common/hooks";
import { Icon, mdSize, smSize } from "../../../../../common/icon";

import {
  Loading,
  Pagination,
  Button,
  MoreOptions,
} from "../../../../primitives/index";
import { themesProjectsGetAttempt } from "../../themesProjectsTab/projectsTab.action";
import FordNewProjectModal from "../../../../../common/components/fordNewProjectModal";
import AddRelatedProjectComponent from "../relatedProjectsBlock/addRelatedProjectModal";
import NewProjectModal from "../../../themesCommon/newProjectModal/index";
import decisionOptions from "../relatedProjectsBlock/relatedProjects.constant";

import ProjectRow from "./projectRow.component";
import styles from "./styles.module.scss";

const MainProjectsBlock = (props) => {
  const { currentThemeData } = props;
  const {
    themesReducer: {
      themesProjectsReducer: { projects, loadingProj, projectListMeta },
    },
    councilReducer: { selectedCouncil },
  } = useSelector((state) => state);
  const isFord = selectedCouncil?.name === "Ford";
  const popup = useModelPopup();

  const [pageSetting, setPageSetting] = useState({
    pageSize: 20,
    current: 1,
    hideOnSinglePage: true,
    showTitle: false,
    total: projects?.length || 0,
  });
  const [projList, setProjList] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    setPageSetting((prev) => ({
      ...prev,
      total: projectListMeta.total || 0,
    }));
  }, [projectListMeta]);

  const handlePagingChange = (page) => {
    setPageSetting((prev) => ({
      ...prev,
      current: page,
    }));
  };
  useEffect(() => {
    if (currentThemeData) {
      dispatch(
        themesProjectsGetAttempt({
          themeId: currentThemeData.id,
          page: 1,
          overview: true,
        })
      );
    }
  }, [currentThemeData]);

  useEffect(() => {
    if (pageSetting?.current > 1) {
      dispatch(
        themesProjectsGetAttempt({
          themeId: currentThemeData.id,
          page: pageSetting?.current,
          overview: true,
        })
      );
    }
  }, [pageSetting?.current]);

  useEffect(() => {
    if (projects.length) {
      setProjList(projects);
    }
  }, [projects, selectedCouncil]);

  //console.log("------------------->", projList);
  const handleAddProjectClick = () => {
    popup.show({
      title: "Link Theme to Related Project",
      component: (
        <AddRelatedProjectComponent
          itemList={projects || []}
          currentThemeId={currentThemeData.id}
        />
      ),
    });
  };

  const handleMoreOptionClick = (val) => {
    if (val === "relatedProject") {
      handleAddProjectClick();
    }
    if (val === "newProject") {
      if (selectedCouncil?.name === "Ford") {
        popup.show({
          title: "Create Project",
          height: "80%",
          component: (
            <FordNewProjectModal data={currentThemeData} instance="theme" />
          ),
        });

        return;
      }

      popup.show({
        title: currentThemeData?.name,
        component: <NewProjectModal mode="modal" />,
      });
    }
  };
  if (loadingProj) {
    return <Loading />;
  }
  return (
    <div className={styles.overviewContainer}>
      <span className={styles.overviewTitle}>
        {selectedCouncil?.settings?.themes_display_name_singular || "Theme"}{" "}
        Projects
      </span>
      <div className={styles.btnWrp}>
        <MoreOptions
          options={
            selectedCouncil?.name === "Firmenich" ||
            selectedCouncil?.name === "Ford"
              ? [decisionOptions[0]]
              : decisionOptions
          }
          className={styles.moreOptWrp}
          onClick={handleMoreOptionClick}
          {...mdSize}
          iconName="icn-add"
        />
      </div>
      <div className={styles.overviewBlock}>
        <div className={styles.container}>
          <div className={styles.grid}>
            <div className={styles.gridHeader}>
              <div className={styles.companycol}>Project</div>
              {!isFord ? <div className={styles.col}>Companies </div> : null}

              <div className={styles.ownerCol}>Owner</div>
              <div className={styles.col}>Access</div>
              {selectedCouncil.traction_tag !== "firmenich" ? (
                <div className={styles.col}>Project Stage</div>
              ) : null}
              <div className={styles.col}>Status </div>
              <div className={styles.shortCol}> </div>
            </div>

            <div className={styles.gridBody}>
              {projList?.length
                ? projList.map((proj, i) => (
                    <ProjectRow
                      isFord={isFord}
                      project={proj}
                      selectedCouncilName={selectedCouncil?.name}
                      currentThemeData={currentThemeData}
                    />
                  ))
                : null}
            </div>
          </div>
          <div className={styles.paginationCon}>
            <Pagination {...pageSetting} onChange={handlePagingChange} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default MainProjectsBlock;
